import React from 'react';
import { RequiredFieldNotice } from '../basic/RequiredFieldNotice';
import { CenterAll } from '../styled';
import { FormHeader } from '../basic/FormHeader';
import {
  ProfileEventTypes,
  useProfileUpComm
} from '../screens/Profile/ProfileData';
import { UserDataKeys } from '../screens/Profile/UserDataKeys';
import { LoginInput } from '../data-inputs/validated/LoginInput';
import { navigateTo } from '../../navigation/path-builder';
import { trackingClient, useTrackLoadUnload } from '../../ext/tracking';
import { EnterAwareButton } from '../magma-wrap/EnterAwareButton';
import { Marker } from '../meta/Marker';
import { Button } from '../magma-wrap/Button';
import { featureFlags, RipsawInstitution } from '../../frontendBackend';
import { UsernameInput } from '../data-inputs/validated/UsernameInput';
import { getUserNameFromQuery } from '../../signinWidgetUtils/widget-mod/url-util';

export const TEST_ID = {
  MARKER: 'marker-student-discover',
  SCHOOL_SEARCH: 'button-school-search'
};

export interface DiscoverProps {
  showSchoolsearch?: boolean;
}

export const Discover: React.FC<DiscoverProps> = () => {
  const skipEmailVerification = window.backend?.parsedUXmode?.skipEmailVerification?.value;
  const institution: RipsawInstitution = window.backend?.uxModeInstitution;
  const showSchoolSearchButton: boolean | undefined =
    !institution || institution?.inCommon?.enabled;
  const isInCommonEnabled: boolean | undefined =
    institution && institution?.inCommon?.enabled;
  const upComm = useProfileUpComm();
  const category = trackingClient.event.discovery;
  useTrackLoadUnload(category);
  let username = getUserNameFromQuery();
  const isSubmitDisabled = () => !upComm.ctx.isValid && !(username.length > 0);

  const discoverUser = async () => {
    upComm.sendMsg({
      type: ProfileEventTypes.discoverUsername,
      data: {
        whenNotActivating: async (userData: any) => {
          if (userData[UserDataKeys.login]) {
            username = userData[UserDataKeys.login];
          }
          navigateTo.register.createProfile({
            username
          });
        }
      }
    });
  };
  const initiateSchoolSignup = () => {
    /* istanbul ignore next 
    cannot test for location change */
    if (isInCommonEnabled) {
      (document.location as any) = '/oidc/register/satosa?sawsEntityId=' + encodeURIComponent(institution.entityNumber);
    } else {
      navigateTo.register.studentSchoolSearch({});
    }
  };

  return (
    <>
      <Marker testId={TEST_ID.MARKER}/>

      <FormHeader>Create Account</FormHeader>
      <RequiredFieldNotice/>

      {!skipEmailVerification && <LoginInput upComm={upComm} autoFocus defaultValue={username}
        helperMessage={'Consider using your institutional email. This will serve as your username.'}/>
      }
      {skipEmailVerification && <UsernameInput upComm={upComm} autoFocus defaultValue={username}/>
      }
      <EnterAwareButton
        testId="submit-button"
        id="submit-button"
        value="Next"
        isFullWidth={true}
        disabled={isSubmitDisabled()}
        onClick={() => {
          category.nextButtonClick();
          discoverUser();
        }}
      />
      {featureFlags.isSchoolSearchVisible() && showSchoolSearchButton && (
        <React.Fragment>
          <CenterAll>OR</CenterAll>
          <Button
            onClick={initiateSchoolSignup}
            value="Sign Up with School Account"
            testId={TEST_ID.SCHOOL_SEARCH}
            block
          />
        </React.Fragment>
      )}
    </>
  );
};